
import { ButtonFieldConfig, DisplayTranformation, DynamicFormArray, FieldOption, FormFieldConfig, Props } from './form.model';
import { AdjustedTenureNumber, Attachment, BrandDropdown, DealerDropdown, DefaultDropdown, FieldNames, JobCode, SpinIdNumber, TenureDropdown, TenureSubDropdown, centralArea, commentsText, easternArea, southernArea, tenureOptions, westernArea } from './form-fields.model';
import { ApiStatus, FETCH_METHODS, SearchConfig } from './api.model';
import { DataTableSchema, DefaultTableSchema } from './dynamic-data-table.model';
import { BUTTON_NAMES } from './common.model';

export const brandTenureEditTitle = "Adjustment For Brand Tenure";



export const TenureTitle = "Tenure";

export const TenureAreaOptions = [{ fieldLabel: westernArea, fieldValue: 31 }, { fieldLabel: centralArea, fieldValue: 32 }, { fieldLabel: easternArea, fieldValue: 33 }, { fieldLabel: southernArea, fieldValue: 34 }]
export const tenureAreaRegionField:FormFieldConfig = {
  ...structuredClone(DefaultDropdown), displayName:'Area / Region', fieldName:FieldNames['Area'], options: [], multiple :true ,isLoading:false
}

export const TennureScreens = {
  BrandTenure: 'brand',
  DealerTenure: 'dealer',
  JobTenure: 'job',
  LexusTenure: 'lexus',
  TtnTenure: 'ttn',
  OemTenure: 'oem'
}

export const SubTenureOptions: Record<string, Array<FieldOption>> = {
  [tenureOptions['BaseTenure']]: [{ fieldLabel: 'Brand', fieldValue: TennureScreens['BrandTenure'] }, { fieldLabel: 'Dealer', fieldValue: TennureScreens['DealerTenure'] }, { fieldLabel: 'Job', fieldValue: TennureScreens['JobTenure'] }],
  [tenureOptions['DescritionaryTenure']]: [{ fieldLabel: 'Lexus Grant', fieldValue: TennureScreens['LexusTenure'] }, { fieldLabel: 'OEM', fieldValue: TennureScreens['OemTenure'] }, { fieldLabel: 'T-TEN Only', fieldValue: TennureScreens['TtnTenure']}]
}

const FormFieldTabArray: FormFieldConfig[] = ([
  { ...structuredClone(TenureDropdown), defaultValue: tenureOptions['BaseTenure'], required: true, showSelect: false },
  {
    ...structuredClone(TenureSubDropdown), defaultValue: TennureScreens['BrandTenure'], required: true, showSelect: false,
    options: SubTenureOptions[tenureOptions['BaseTenure']], selectedValue: TennureScreens['BrandTenure'], displayTranformation: DisplayTranformation.none
  }
]);

export const FormButtonArray: ButtonFieldConfig[] = structuredClone([{ name: BUTTON_NAMES.TenureAdjustment }]);


export const TenureFormArray: DynamicFormArray = {
  FieldsArray: FormFieldTabArray,
}

export const TenureProps: Props = {
  isBreadCrumbSection: true,
}

export const EditActionButtons: ButtonFieldConfig[] = [
    { isDisabled: false, name: BUTTON_NAMES.Create },
    { isDisabled: false, name: BUTTON_NAMES.Cancel }
]

export const TenureAttchmentSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "tenureUpload",
  body:{
    [FieldNames['Attachment']]: '',
    [FieldNames['SpinId']]: '',
    type: '',
    tenureId: ''
  },
  headers:{}
}


export const TenureUpdateSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "updateTenure",
  body: {
    "spinId": "",
    "adjustedTenure": "",
    "updatedBy":"",
    "updatedByName": '',
    "dealerCode":'',
    "jobCode":'',
    "comments": "",
    "isOem":false,
    "type": "brand"
  }
}

const ForUpdateFormFieldArray: FormFieldConfig[] = structuredClone([
  {...structuredClone(SpinIdNumber),required:true},
  {...structuredClone(DefaultDropdown), fieldName: FieldNames.Type, displayName: 'Tenure Type',defaultValue: TennureScreens['BrandTenure'], required: true, showSelect: false,
    options: [{ fieldLabel: 'Brand', fieldValue: 'brand' }, { fieldLabel: 'Dealer', fieldValue: 'dealer' }, { fieldLabel: 'Job', fieldValue: 'job' }]
    ,selectedValue: 'brand', displayTranformation: DisplayTranformation.none
  }, {...structuredClone(BrandDropdown),required:true},
  {...structuredClone(DealerDropdown),fieldName:FieldNames['DealerCode'], displayName: 'Dealer Code / Dealer Name', options:[], displayTranformation: DisplayTranformation.none, isAutoComplete: true, isLoading: true},
  JobCode,{...structuredClone(AdjustedTenureNumber), pattern: String.raw`^(?:[1-9][0-9]*)$`},
  commentsText,
  {...structuredClone(Attachment), multiple:true}
]);

export const BrandTenureEditFilterSchema: DynamicFormArray = {
    FieldsArray: ForUpdateFormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: TenureUpdateSearchConfig,
    title: brandTenureEditTitle,
    resetAfterSubmit: true,
    isCloseIcon:true
}
export const EditActionFieldSchema: DynamicFormArray = {
    ...structuredClone(BrandTenureEditFilterSchema),
    ButtonsArray: EditActionButtons,
}

export const TenureExportSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: 'getSignedUrl',
  body: {
    bucketName: '',
    key: '',
    type: 'Download'
  }
}

export const TenureDefaultTableSchema: DataTableSchema = {
  ...structuredClone(DefaultTableSchema),
  columnSchema: [],
  isSearchRequired: true,
  serverSidePaginatation: true,
  searchInfo: {
    placeholder: 'Filter',
    filtarableSpecificFields: []
  },
  pageSizeOptions: {
    pageSize: [10, 25, 50, 100]
  }
}

export const TenureDropDownSearchConfig:SearchConfig = {
  method: FETCH_METHODS['Get'],
  path: 'getDropdownsForTenure'
}

export type successFailureMsg = Record<ApiStatus, string>
